import { DRM_TYPES, STREAM_TYPES } from './constants';
import { getBestDRMForDash, getBestDRMForHls } from './utils';
export async function decideProfile(playerContext, preferredDRM = '') {
    if (!playerContext.player) {
        console.error('No player detected');
        return { profileName: '', drm: '' };
    }
    const player = playerContext.player;
    const supportedTech = player.getSupportedTech();
    const supportedDRM = await player.getSupportedDRM();
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if ((isSafari && supportedTech.some((tech) => tech.streaming === 'hls') && supportedDRM.includes(DRM_TYPES.FAIRPLAY)) ||
        preferredDRM === DRM_TYPES.FAIRPLAY) {
        return { profileName: STREAM_TYPES.HLS, drm: DRM_TYPES.FAIRPLAY };
    }
    const { bestWithDRM, bestDRM } = determineBestWithDRM(supportedTech, { supportedDRM, preferredDRM });
    const bestWithoutDRM = determineBestWithoutDRM(supportedTech);
    return bestWithDRM ? { profileName: bestWithDRM, drm: bestDRM } : { profileName: bestWithoutDRM, drm: bestDRM };
}
function determineBestWithDRM(supportedTech, drmInfo) {
    let bestWithDRM = '';
    let bestDRM = '';
    const techMap = {
        dash: { drm: DRM_TYPES.WIDEVINE, stream: STREAM_TYPES.DASH },
        hls: { drm: DRM_TYPES.FAIRPLAY, stream: STREAM_TYPES.HLS },
        whep: {
            drm: drmInfo.preferredDRM === DRM_TYPES.FAIRPLAY ? DRM_TYPES.FAIRPLAY : '',
            stream: drmInfo.preferredDRM === DRM_TYPES.FAIRPLAY ? STREAM_TYPES.HLS : STREAM_TYPES.DASH
        }
    };
    for (const tech of supportedTech) {
        if (bestWithDRM)
            continue;
        if (techMap[tech.streaming]) {
            const { drm, stream } = techMap[tech.streaming];
            if (drmInfo.preferredDRM !== drm) {
                bestDRM =
                    tech.streaming === STREAM_TYPES.DASH ? getBestDRMForDash(drmInfo) : getBestDRMForHls(drmInfo);
                if (bestDRM)
                    bestWithDRM = stream;
            }
        }
    }
    return { bestWithDRM, bestDRM };
}
function determineBestWithoutDRM(supportedTech) {
    for (const tech of supportedTech) {
        return tech.streaming;
    }
    return '';
}
